export const SOFTLINE_PERMISSION_ABAU_INVOICE_LINK = 'SOFTAPPS.ABAU.DESPATCHADVICE_LINK';
